/** SAP Business One / S/4HANA ERP adapter — STUB. Implements ERPPort. */
export function createSapERP() {
  const err = () => { throw new Error("SAP_ERP_NOT_IMPLEMENTED"); };
  return {
    async status() { return { status: "not_connected", vendor: "sap" }; },
    async listInvoicesForActor() { err(); },
    async listCatalog() { err(); },
    async createQuote() { err(); },
    async createOrder() { err(); },
  };
}
